import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DescriptionAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${Spacing.S8};
`
